<template>
	<div>
		<alert-container/>
		<active-call/>
		<header :class="headerClass" role="banner">
			<nav>
				<ul>
					<li>
						<AppLink
							:to="{name: $can('accessDashboard') ? 'dashboard' : 'welcome'}"
							class="nav--dashboard">Dashboard
						</AppLink>
					</li>
					<TheModeContextual/>
				</ul>
				<ul>
					<template>
						<!--						<li>-->
						<!--							<v-tooltip placement="bottom">-->
						<!--								<button class="nav&#45;&#45;search" @click.prevent="showSearchModal()">Search</button>-->
						<!--								<template v-slot:popover>-->
						<!--									Search-->
						<!--									&lt;!&ndash;									<AppKeyCombination :keys="['/']"/>&ndash;&gt;-->
						<!--								</template>-->
						<!--							</v-tooltip>-->
						<!--						</li>-->
						<li v-if="$can('lead.viewAny')">
							<v-tooltip placement="bottom">
								<AppLink
									:to="{name: 'leads.index'}"
									class="nav--leads">Leads
								</AppLink>
								<template v-slot:popover>
									Leads
								</template>
							</v-tooltip>
						</li>
						<li v-if="$can('client.viewAny')">
							<v-tooltip placement="bottom">
								<AppLink
									:to="{name: 'clients.index'}"
									class="nav--clients">Clients
								</AppLink>
								<template v-slot:popover>
									Clients
								</template>
							</v-tooltip>
						</li>
						<template v-if="$authed().isStaff">
							<li>
								<v-tooltip placement="bottom">
									<AppLink
										:to="{name: 'serviceProviders'}"
										class="nav--serviceProviders">Service Providers
									</AppLink>
									<template v-slot:popover>
										Service Providers
									</template>
								</v-tooltip>
							</li>
						</template>
						<template v-if="!$authed().isStaff">
							<TheReferralContextual v-if="$can('introduction.create')"/>
							<TheOrderContextual v-if="$can('product.buy')"/>
							<!--							<li><router-link-->
							<!--								:to="{name: 'products.index'}"-->
							<!--								class="nav&#45;&#45;products">Products</router-link></li>-->
							<!--							<li v-if="$can('service.viewAny')"><router-link-->
							<!--								:to="{name: 'services.index'}"-->
							<!--								class="nav&#45;&#45;services">Services</router-link></li>-->
						</template>
						<template v-else>
							<!--							<li v-if="$can('serviceProvider.viewAny')"><router-link-->
							<!--								:to="{name: 'serviceProviders'}"-->
							<!--								class="nav&#45;&#45;serviceproviders"><span>Service Providers</span></router-link></li>-->
						</template>
						<!--						<TheNotificationsContextual/>-->
					</template>
					<TheAccountContextual/>
					<!--					<li v-if="$can('missedLead.viewAny')"><router-link-->
					<!--						:to="{name: 'missedLeads.index'}"-->
					<!--						class="left-nav&#45;&#45;leads"><span>Missed Leads</span></router-link></li>-->
					<!--					<li v-if="$can('factFind.viewAny')"><router-link-->
					<!--						:to="{name: 'factFinds.index'}"-->
					<!--						class="left-nav&#45;&#45;factfinds"><span>Fact Finds</span></router-link></li>-->
					<!--					<li v-if="$can('searchPackBundle.viewAny')"><router-link-->
					<!--						:to="{name: 'searchPackBundles.index'}"-->
					<!--						class="left-nav&#45;&#45;bundles"><span>Search Pack Bundles</span></router-link></li>-->
					<!--					<li v-if="$can('panel.viewAny')"><router-link-->
					<!--						:to="{name: 'panels'}"-->
					<!--						class="left-nav&#45;&#45;panels"><span>Panels</span></router-link></li>-->
					<!--					<li v-if="$can('team.viewAny')"><router-link-->
					<!--						:to="{name: 'teams.index'}"-->
					<!--						class="left-nav&#45;&#45;teams"><span>Teams</span></router-link>-->
					<!--					</li>-->
					<!--					<li v-if="$can('user.viewAny')"><router-link-->
					<!--						:to="{name: 'users.index'}"-->
					<!--						class="left-nav&#45;&#45;users"><span>Users</span></router-link>-->
					<!--					</li>-->
					<!--					&lt;!&ndash;					<li v-if="$can('campaign.viewAny')"><router-link&ndash;&gt;-->
					<!--					&lt;!&ndash;						:to="{name: 'campaigns'}"><span>Campaigns</span></router-link></li>&ndash;&gt;-->
					<!--					&lt;!&ndash;					<li v-if="$can('instruction.viewAny')"><router-link&ndash;&gt;-->
					<!--					&lt;!&ndash;						class="left-nav&#45;&#45;instructions"&ndash;&gt;-->
					<!--					&lt;!&ndash;						:to="{name: 'instructions.index'}"><span>Instructions</span></router-link></li>&ndash;&gt;-->
					<!--					&lt;!&ndash;					<li v-if="$can('commission.viewAny')"><router-link&ndash;&gt;-->
					<!--					&lt;!&ndash;						:to="{name: 'commissions.index'}"><span>Commissions</span></router-link></li>&ndash;&gt;-->
					<!--					&lt;!&ndash;					<li v-if="$can('comparison.viewAny')"><router-link&ndash;&gt;-->
					<!--					&lt;!&ndash;						:to="{name: 'comparisons.index'}"><span>Comparisons</span></router-link></li>&ndash;&gt;-->
					<!--					&lt;!&ndash;					<li v-if="$can('invitation.viewAny')"><router-link&ndash;&gt;-->
					<!--					&lt;!&ndash;						:to="{name: 'invitations.index'}"><span>Invitations</span></router-link></li>&ndash;&gt;-->
					<!--					&lt;!&ndash;					<li v-if="$can('offer.viewAny')"><router-link&ndash;&gt;-->
					<!--					&lt;!&ndash;						:to="{name: 'offers.index'}"><span>Offers</span></router-link>&ndash;&gt;-->
					<!--					&lt;!&ndash;					</li>&ndash;&gt;-->
					<!--					&lt;!&ndash;					<li v-if="$can('group.viewAny')"><router-link&ndash;&gt;-->
					<!--					&lt;!&ndash;						:to="{name: 'groups'}"><span>Groups</span></router-link></li>&ndash;&gt;-->
					<!--					&lt;!&ndash;					<li><router-link :to="{name: 'calendar'}">Calendar</router-link></li>&ndash;&gt;-->
					<!--					&lt;!&ndash;					<li v-if="$can('invoice.viewAny')"><router-link&ndash;&gt;-->
					<!--					&lt;!&ndash;						:to="{name: 'invoices.index'}">Invoices</router-link></li>&ndash;&gt;-->
					<!--					&lt;!&ndash;					<li v-if="$can('instruction.viewAny')"><router-link&ndash;&gt;-->
					<!--					&lt;!&ndash;						:to="{name: 'instructions.index'}">Instructions</router-link></li>&ndash;&gt;-->
					<!--					&lt;!&ndash;					<li v-if="$can('idCheck.viewAny')"><router-link&ndash;&gt;-->
					<!--					&lt;!&ndash;						:to="{name: 'idChecks.index'}">Id Checks</router-link></li>&ndash;&gt;-->
					<!--					&lt;!&ndash;					<li v-if="$can('searchPack.viewAny')"><router-link&ndash;&gt;-->
					<!--					&lt;!&ndash;						:to="{name: 'searchPacks.index'}">Search Packs</router-link></li>&ndash;&gt;-->
					<!--					<li v-if="$can('report.viewAny')"><router-link-->
					<!--						:to="{name: 'report'}"-->
					<!--						class="left-nav&#45;&#45;report"><span>Report</span></router-link></li>-->
					<!--					<li v-if="$can('serviceProvider.updateSettings')"><router-link-->
					<!--						:to="{name: 'settings'}"-->
					<!--						class="left-nav&#45;&#45;settings"><span>Settings</span></router-link></li>-->
					<!--					<li v-if="$can('healthMonitor.viewAny')"><router-link-->
					<!--						:to="{name: 'healthMonitor'}"-->
					<!--						class="left-nav&#45;&#45;health"><span>Health Monitor</span></router-link></li>-->
					<!--					<li v-if="$can('applicationRequest.viewAny')"><router-link-->
					<!--						:to="{name: 'requestLog'}"-->
					<!--						class="left-nav&#45;&#45;requests"><span>Logs</span></router-link></li>-->
					<!--					<template v-if="$authed().isStaff">-->
					<!--						&lt;!&ndash;					<li><router-link :to="{name: 'accounts'}">Accounts</router-link></li>&ndash;&gt;-->
					<!--						&lt;!&ndash;					<li><router-link&ndash;&gt;-->
					<!--						&lt;!&ndash;						:to="{name: 'tools.estateAgentComparison'}">Estate Agent Comparison</router-link></li>&ndash;&gt;-->
					<!--						<li><router-link-->
					<!--							:to="{name: 'tools.postcodeManager'}"-->
					<!--							class="left-nav&#45;&#45;postcodes"><span>Postcode Manager</span></router-link>-->
					<!--						</li>-->
					<!--						&lt;!&ndash;					<li><router-link :to="{name: 'tools.jobMonitor'}">Job Monitor</router-link></li>&ndash;&gt;-->
					<!--					</template>-->
				</ul>
				<!--					<form class="search" @submit.prevent>-->
				<!--						<input-->
				<!--							class="soft" type="text" placeholder="Search clients" v-model="search"-->
				<!--							@change="searchClients()">-->
				<!--						<button-->
				<!--							v-if="search.length"-->
				<!--							type="reset"-->
				<!--							class="search__clear" @click="clearSearch()">Clear-->
				<!--						</button>-->
				<!--					</form>-->
			</nav>
			<!--			<AppBreadcrumb v-if="$can('accessDashboard')"/>-->
		</header>
		<main role="main">
			<div class="content-safe-space">
				<slot/>
			</div>
		</main>
		<AppDownloadManager/>
		<Modal/>
	</div>
</template>
<script>
import AppDownloadManager from "@/common/components/AppDownloadManager.vue";
import autoLogout from "@/mixins/autoLogout";
import {mapActions} from "vuex";
import AppBreadcrumb from "../../../components/AppBreadcrumb.vue";
import TheAccountContextual from "../components/TheAccountContextual";
import TheModeContextual from "../components/TheModeContextual.vue";
import TheNotificationsContextual from "../components/TheNotificationsContextual";
import TheOrderContextual from "../components/TheOrderContextual.vue";
import TheReferralContextual from "../components/TheReferralContextual.vue";

export default {
	components: {
		AppDownloadManager,
		TheModeContextual,
		TheAccountContextual,
		TheNotificationsContextual,
		TheOrderContextual,
		TheReferralContextual,
		AppBreadcrumb,
	},

	mixins: [
		autoLogout,
	],

	data() {
		return {
			online: true,
			search: "",
			stoppingImpersonation: false,
		};
	},

	computed: {
		headerClass() {
			return {
				impersonating: this.$impersonator(),
			};
		},
		accountClass() {
			return {
				"account--impersonating": this.$impersonator(),
			};
		},
		notificationsClass() {
			return {
				"account__notifications--unread": this.$authed().unreadNotifications,
			};
		},
		status() {
			return this.online ? "Online" : "Away";
		},
		buttonStatus() {
			return this.online ? "Switch to Away" : "Switch to Online";
		},
	},

	methods: {
		...mapActions("cart", [
			"getCart",
		]),
		showSearchModal() {
			this.$vmodal.replace({
				component: () => import("../components/modals/Search.vue"),
			});
		},
		toggleStatus() {
			this.online = !this.online;
			http().patch("authed/status", {
				status: this.online ? "online" : "away",
			});
		},
		searchClients() {
			this.$router.push({name: "clients.index", query: {search: this.search}});
		},
		clearSearch() {
			this.search = "";
			this.$router.push({name: "clients.index"});
		},
		stopImpersonation() {
			this.stoppingImpersonation = true;
			this.$store.dispatch("authStore/endImpersonation").then(() => {
				this.stoppingImpersonation = false;
			});
		},
		// watchKeys(event) {
		// 	let keys = {
		// 		191: () => {
		// 			this.showSearchModal();
		// 		},
		// 	};
		// 	if (!keys.hasOwnProperty(event.which)) {
		// 		return;
		// 	}
		// 	keys[event.which]();
		// },
	},

	created() {
		if (this.$can("product.buy")) {
			this.getCart();
		}

		if (
			this.$store.state.authStore.justLoggedIn &&
			!this.$authed()?.isStaff &&
			!this.$authed()?.settings.dismiss_welcome_message &&
			!this.$authed()?.service_provider.private_introducer
		) {
			// this.$vmodal.open({
			// 	component: require("../../../components/modals/welcome").default,
			// });
		}
	},

	// beforeMount() {
	// 	window.addEventListener("keyup", this.watchKeys);
	// },
	// beforeDestroy() {
	// 	window.removeEventListener("keyup", this.watchKeys);
	// },
};
</script>
